import React from "react";
import { PageContainer } from "./AgentsViewPageV2.styled";
import { Paginator, Content, FiltersContainer } from "./components";
import { useAgentsPage } from "./hooks/useAgentsPage";
import { AgentsProvider } from "./context/AgentsContext";
import Breadcrumb from "../AgentsView/components/Breadcrumb/Breadcrumb";
import Header from "../AgentsView/components/Header/Header";

const AgentsViewPageV2Content = () => {
  const {
    loading,
    error,
    agents,
    agentsMeta,
    filters,
    filterHandlers,
    filterUI,
    handlePageChange,
    handleItemsPerPageChange,
    handleRefresh,
  } = useAgentsPage();

  return (
    <PageContainer>
      {/* <Breadcrumb /> */}
      <Header />
      <FiltersContainer
        loading={loading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
      />
      <Content
        loading={loading}
        error={error}
        agents={agents}
        onRefresh={handleRefresh}
      />
      <Paginator
        meta={agentsMeta}
        onPageChange={handlePageChange}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
    </PageContainer>
  );
};

const AgentsViewPageV2 = () => {
  return (
    <AgentsProvider>
      <AgentsViewPageV2Content />
    </AgentsProvider>
  );
};

export default AgentsViewPageV2;

